import { PartnerSetting } from 'src/graphql';

export enum SettingsPreferencesFormFields {
  AnsweringServices = PartnerSetting.AnsweringServicesOn,
  UsesProvisionForSupport = PartnerSetting.UsesProvisionForSupportOn,
  SlaTaxExemption = PartnerSetting.SlaTaxExemption,
}

export interface SlaTaxExemptionFormModel {
  exempt: boolean;
  exemptaxCustomerId: string;
}

export type SettingsPreferencesFormFieldsFormModel = {
  [SettingsPreferencesFormFields.AnsweringServices]: boolean;
  [SettingsPreferencesFormFields.UsesProvisionForSupport]: boolean;
  [SettingsPreferencesFormFields.SlaTaxExemption]: SlaTaxExemptionFormModel;
};

export type BooleanPreferencesFormFields = Exclude<
  SettingsPreferencesFormFields,
  SettingsPreferencesFormFields.SlaTaxExemption
>;

export type PreferencesChange = {
  rule: SettingsPreferencesFormFields;
  value: boolean | string;
  id: string | null;
  partnerId: number | null;
};
